<template>
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
        d="M12.7443 0.0451624C12.6134 -0.0153796 12.4592 -0.0153796 12.3284 0.0451624L0.257318 5.61641C0.0280214 5.72235 -0.0648234 5.97979 0.0499201 6.19145C0.115235 6.31193 0.23814 6.39705 0.381719 6.42123L5.17252 7.22563L6.04395 11.6479C6.07962 11.8292 6.23685 11.9692 6.4344 11.9955C6.45624 11.9984 6.47828 11.9998 6.50031 11.9998C6.67629 11.9998 6.83717 11.9081 6.91584 11.7628L12.9514 0.620274C13.0662 0.408666 12.9735 0.15118 12.7443 0.0451624Z"
        fill="white"/>
     </svg>
</template>
